import { useGlobalContext } from "@/context/GlobalContext";

interface WalletBalanceSectionProps {
  balance: number;
  pendingBalance?: number;
}

const WalletBalanceSection: React.FC<WalletBalanceSectionProps> = ({
  balance,
  pendingBalance = 0,
}) => {
  const { ucdT } = useGlobalContext();
  const symbol = ucdT?.symbols || "₹";

  return (
    <div className="pb-5 border-b border-[#E4E7EC]">
      <div className="space-y-2">
        <h5 className="text-[#667085] text-sm leading-[18px] font-medium">
          Available Balance
        </h5>
        <h3 className="text-[#FF6600] text-2xl leading-9 tracking-[-1%] font-semibold">
          {symbol} {balance}
        </h3>
        {pendingBalance > 0 && (
          <p className="text-xs text-[#667085]">
            Pending: {symbol} {pendingBalance} (released after brand payment,
            approval, and a 3-day hold)
          </p>
        )}
      </div>
    </div>
  );
};

export default WalletBalanceSection;
